import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main";
import AboutPage from "../Pages/AboutPage/AboutPage";
import Blogs from "../Pages/Blogs/Blogs";
import Home from "../Pages/Home/Home";
import ProjectDetails from "../Pages/ProjectDetails/ProjectDetails";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/blogs",
        element: <Blogs />,
      },
      {
        path : '/about',
        element : <AboutPage></AboutPage>
      },
      {
        path: "/projects/:_id",
        element: <ProjectDetails />,
        loader: ({ params }) =>
          fetch(
            `https://portfolio-server-sage.vercel.app/projects/${params._id}`
          ),
      },
    ],
  },
]);

export default routes;
